import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PublicClientApplication, InteractionType, AuthenticationResult } from '@azure/msal-browser';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AdalauthService {

  private msalInstance: PublicClientApplication;

  constructor(
    private http: HttpClient,
    // private adalService: MsAdalAngular6Service,
  ) {
    this.msalInstance = new PublicClientApplication({
      auth: {
        clientId: environment.clientId, // '9d5b27e3-e8ee-4d50-b0bd-6dd88f9a2456',
        authority: 'https://login.microsoftonline.com/' + environment.tenant,
        redirectUri: environment.redirectUri,
      }
    });
  }

  async login() {
    try {
      await this.msalInstance.loginPopup({
        scopes: ['openid', 'profile', 'User.Read']
      });
    } catch (error) {
      console.error('Login failed:', error);
    }
  }

  logout() {
    this.msalInstance.logoutPopup();
  }
}


